import buildSimpleStringFilter from '../buildSimpleStringFilter'

const DealsFilter = buildSimpleStringFilter({
  key: 'deals',
  expandedOnInit: false,
})

DealsFilter.tooltip = 'Filters.dealsTooltip'

export default DealsFilter
